module.exports = __webpack_public_path__ + "static/fpl_green-a6d3f14097878555d19149d888802b48.png";